import { Controller } from "stimulus"

export default class extends Controller {

  enableButton(target) {
    $(this[target + "Target"]).removeClass('loading').prop('disabled', false)
  }

  disableButton(target) {
    $(this[target + "Target"]).addClass('loading').prop('disabled', true)
  }

  show(target) {
    this[target + "Target"].setAttribute("style", "")
  }

  hide(target) {
    this[target + "Target"].setAttribute("style", "display:none")
  }
}
